import { language as lan_index } from "./index";
import { language as lan_regist } from "./regist/index";
import { language as lan_storeProduct } from "./store-product";
import { language as lan_contents } from "./contents/index";
import { language as lan_dashboard } from "./dashboard/index";
import { language as lan_cart } from "./cart/index";
import { language as lan_productDetail } from "./detail/index";
import { language as lan_catalog } from "./catalog/index";
import { language as lan_builder } from "./builder/index";
import { language as lan_stores } from "./stores/index";
import { language as lan_myAccount } from "./my-account/index";
import { language as lan_addressBook } from "./address-book/index";
import { language as lan_business } from "./business/index";
import { language as lan_catalogSearch } from "./catalog-search/index";
import { language as lan_resourceLibrary } from "./resource-library/index";
import { language as lan_payments } from "./payments/index";
import { language as lan_taxes } from "./taxes/index";
import { language as lan_woocommercePlugin } from "./woocommerce-plugin/index";
import { language as lan_directCheckoutEntry } from "./direct-checkout-entry/index";
import { language as lan_payment } from "./payment/index";
import { language as lan_forgetPassword } from "./forget-password";
import { language as lan_login } from "./login/index";
import { language as lan_terms } from "./terms";
import { language as lan_privacyPolicy } from "./privacy-policy";
import { language as lan_storeConnection } from "./store-connection/index";
import { language as lan_resetPassword } from "./reset-password/index";
import { language as lan_checkout } from "./check-out/index";
import { language as lan_billingMethod } from "./billing-method/index";
import { language as lan_combine_order_settings } from "./combine-order-settings/index";
import { language as lan_partnerVerify } from "./partner-verify/index";
import { language as lan_storeEmailSetting } from "./dashboard/store-email-setting";
import {language as lan_integrationwithapi} from "./integration-with-api";
import {language as lan_propertyForm} from "./property-form";
let language = {
    ...lan_index,
    ...lan_regist,
    ...lan_storeProduct,
    ...lan_contents,
    ...lan_dashboard,
    ...lan_cart,
    ...lan_productDetail,
    ...lan_storeConnection,
    ...lan_catalog,
    ...lan_builder,
    ...lan_stores,
    ...lan_myAccount,
    ...lan_addressBook,
    ...lan_business,
    ...lan_catalogSearch,
    ...lan_resourceLibrary,
    ...lan_payments,
    ...lan_taxes,
    ...lan_woocommercePlugin,
    ...lan_directCheckoutEntry,
    ...lan_payment,
    ...lan_forgetPassword,
    ...lan_login,
    ...lan_terms,
    ...lan_privacyPolicy,
    ...lan_resetPassword,
    ...lan_checkout,
    ...lan_billingMethod,
    ...lan_combine_order_settings,
    ...lan_partnerVerify,
    ...lan_storeEmailSetting,
    ...lan_integrationwithapi,
    ...lan_propertyForm
};

export { language }